"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["startFrom", "endAt"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffthreadVideo = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var get_environment_1 = require("../get-environment");

var Sequence_1 = require("../Sequence");

var validate_media_props_1 = require("../validate-media-props");

var validate_start_from_props_1 = require("../validate-start-from-props");

var validate_offthreadvideo_image_format_1 = require("../validation/validate-offthreadvideo-image-format");

var OffthreadVideoForRendering_1 = require("./OffthreadVideoForRendering");

var VideoForDevelopment_1 = require("./VideoForDevelopment");

var OffthreadVideo = function OffthreadVideo(props) {
  var startFrom = props.startFrom,
      endAt = props.endAt,
      otherProps = _objectWithoutProperties(props, _excluded);

  var onDuration = (0, react_1.useCallback)(function () {
    return undefined;
  }, []);

  if (typeof startFrom !== 'undefined' || typeof endAt !== 'undefined') {
    (0, validate_start_from_props_1.validateStartFromProps)(startFrom, endAt);
    var startFromFrameNo = startFrom !== null && startFrom !== void 0 ? startFrom : 0;
    var endAtFrameNo = endAt !== null && endAt !== void 0 ? endAt : Infinity;
    return (0, jsx_runtime_1.jsx)(Sequence_1.Sequence, {
      layout: "none",
      from: 0 - startFromFrameNo,
      showInTimeline: false,
      durationInFrames: endAtFrameNo,
      children: (0, jsx_runtime_1.jsx)(exports.OffthreadVideo, _objectSpread({}, otherProps))
    });
  }

  (0, validate_media_props_1.validateMediaProps)(props, 'Video');
  (0, validate_offthreadvideo_image_format_1.validateOffthreadVideoImageFormat)(props.imageFormat);

  if ((0, get_environment_1.getRemotionEnvironment)() === 'rendering') {
    return (0, jsx_runtime_1.jsx)(OffthreadVideoForRendering_1.OffthreadVideoForRendering, _objectSpread({}, otherProps));
  }

  return (0, jsx_runtime_1.jsx)(VideoForDevelopment_1.VideoForDevelopment, _objectSpread({
    onDuration: onDuration,
    onlyWarnForMediaSeekingError: true
  }, otherProps));
};

exports.OffthreadVideo = OffthreadVideo;